<template>
  <div class="page">
    <PageHeader><div slot="middle">New citizen</div></PageHeader>
    <div class="content pa-8">

      <div class="half-box">
        <v-form ref="form">

          <v-text-field
            :label="$t('Name')"
            outlined
            v-model="form.name"
            class="col-6"
            :rules="rules.nameRules"
          ></v-text-field>

          <v-text-field
            :label="`Address`"
            outlined
            v-model="form.address"
            class="col-6"
          ></v-text-field>

        </v-form>
      </div>

      <div class="half-box d-flex justify-end">
        <v-btn
          color="primary"
          outlined
          class="mr-2"
          @click="createMember"
        >Create citizen</v-btn>

        <v-btn
          style="color: #fff !important"
          color="primary"
        >Create citizen and add task</v-btn>
      </div>

    </div>
  </div>
</template>

<script>
import PageHeader from '@/globals/components/PageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      form: {
        name: '',
        address: '',
      },
      rules: {
        nameRules: [
          (v) => !!v || 'Navn er påkrævet',
        ],
      },
    };
  },
  methods: {
    createMember() {
      this.$refs.form.validate();
      this.$swal.fire('Member added');
    },
  },
};
</script>

<style lang="scss" scoped>
  .content {
    flex: 1;
    background-color: #fff;
    display: flex;
  }

  .half-box {
    width: 50%;
  }
</style>
